export const version = 82;

export const url = `https://static.webrand.com/icons/v${version}/sprites/symbol/sprite.svg`;
